<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">马甲号管理</div>

      <div class="search-wrapper">
         <el-form :inline="true" :model="paramData">
            <el-form-item label="用户ID">
               <el-input placeholder="请输入ID" v-model="paramData.uid"></el-input>
            </el-form-item>
            <el-form-item label="账号类型">
               <el-select v-model="paramData.accountType" placeholder="全部" clearable style="width: 160px">
                  <el-option label="马甲号" :value="1"></el-option>
                  <el-option label="官号" :value="3"></el-option>
                  <el-option label="校园主理人" :value="4"></el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <el-button class="margin-left-10" type="primary" @click="queryList">搜索</el-button>
         <el-button @click="clickReset">重置</el-button>
      </div>

      <div class="action-wrapper">
         <el-button @click="clickTemplateDownload">模版下载</el-button>
         <el-upload :action="actionUrl" name="uploadFile" :with-credentials='true' :show-file-list="false" accept=".xls"
            :before-upload="beforeUpload" :on-success="onSuccess" :on-error="onError">
            <el-button type="primary">导入</el-button>
         </el-upload>
         <el-button type="primary" @click="clickExport">导出</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="listData">
            <el-table-column align="center" label="序号" type="index" width="80">
               <template scope="scope">
                  {{ scope.$index + 1 + ((paramData.pageNum - 1) * paramData.pageSize) }}
               </template>
            </el-table-column>
            <el-table-column align="center" label="用户ID" prop="uid"></el-table-column>
            <el-table-column align="center" label="账号类型" min-width="110">
               <template scope="scope">
                  {{ scope.row.accountTypeName || accountTypeLabel(scope.row.accountType) }}
               </template>
            </el-table-column>
            <el-table-column align="center" label="头像" min-width="160">
               <template scope="{ row }">
                  <div class="flex-row-center margin-bottom-10">
                     <img class="table-img" :src="row.headImgUrl" alt="">
                  </div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="手机号" prop="phone"></el-table-column>
            <el-table-column align="center" label="昵称" prop="nickName"></el-table-column>
            <el-table-column align="center" label="性别">
               <template scope="{ row }">
                  <div>{{ row.gender ? "男" : "女" }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="入学年份" prop="enrollmentYear"></el-table-column>
            <el-table-column align="center" label="实名信息">
               <template scope="{ row }">
                  <div>{{ row.studentNum }}</div>
                  <div>{{ row.name }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="信息" prop="clickCount">
               <template scope="scope">
                  <div>{{ scope.row.campusName }}</div>
                  <div>{{ scope.row.className }}</div>
                  <div>{{ scope.row.gradeClass }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="个性签名" prop="whatsup"></el-table-column>
            <el-table-column align="center" label="操作" width="180" fixed="right">
               <template scope="{ row }">
                  <el-button type="text" style="color: red" @click="clickDelete(row)">删除</el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination v-show="total > 0" layout="prev, pager, next, jumper" :current-page="paramData.pageNum"
            :page-size='paramData.pageSize' :total="total" @current-change="changeCurrentPage">
         </el-pagination>
      </div>

   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         paramData: {
            uid: '',
            accountType: '',
            pageNum: 1,
            pageSize: 10,
         },
         actionUrl: this.$util.domain + '/adminapi/v1/operate/importVestsInfo',
         total: 0,
         listData: [],
      }
   },

   mounted() {
      this.queryList();
   },

   methods: {
      accountTypeLabel(type) {
         var map = { 1: '马甲号', 3: '官号', 4: '校园主理人' };
         return map[type] != null ? map[type] : '—';
      },
      buildVestListBody() {
         var body = {
            pageNum: this.paramData.pageNum,
            pageSize: this.paramData.pageSize,
         };
         var uid = String(this.paramData.uid || '').trim();
         if (uid !== '') {
            var n = Number(uid);
            body.uid = isNaN(n) ? uid : n;
         }
         if (this.paramData.accountType !== '' && this.paramData.accountType != null) {
            body.accountType = Number(this.paramData.accountType);
         }
         return body;
      },
      // 查询列表
      queryList() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/operate/v2/vests/list',
            method: 'POST',
            body: JSON.stringify(this.buildVestListBody())
         }).then((res) => {
            this.total = res.data.data.totalCount || 0;
            this.listData = res.data.data.list || [];
         }).catch((err) => {
            this.total = 0;
            this.listData = [];
         }).finally(() => {
            this.loading = false;
         })
      },
      // 发送删除
      sendDelete(uid) {
         this.$confirm('确定要删除吗？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.loading = true;
            this.$http({
               url: this.$util.domain + "/adminapi/v1/user/userLogout?uid=" + uid,
               method: "GET"
            }).then((res) => {
               if (res.body.error === 10000) {
                  this.queryList();
               } else {
                  this.$util.errorMsg(res.body.message || "请联系管理员");
               }
            }).catch((err) => {
               this.$util.errorMsg(err.message);
            }).finally(() => {
               this.loading = false;
            });
         }).catch(() => { });
      },
      // 点击重置
      clickReset() {
         this.paramData = {
            uid: '',
            accountType: '',
            pageNum: 1,
            pageSize: 10,
         };
         this.queryList();
      },
      // 点击模板下载
      clickTemplateDownload() {
         location.href = "https://admin.gxapp.iydsj.com/template/sockpuppetAaccount.xls";
      },
      // 点击导出
      clickExport() {
         var url = this.$util.domain + '/adminapi/v1/operate/vests/export';
         if (this.paramData.accountType !== '' && this.paramData.accountType != null) {
            url += '?accountType=' + encodeURIComponent(this.paramData.accountType);
         }
         location.href = url;
      },
      // 点击删除
      clickDelete(row) {
         this.sendDelete(row.uid);
      },
      // 切换当前页码
      changeCurrentPage(val) {
         this.paramData.pageNum = val;
         this.queryList();
      },
      // 导入之前
      beforeUpload() {
         this.loading = true;
      },
      //导入成功
      onSuccess(response) {
         this.loading = false;
         if (response.error !== 10000) {
            this.$util.errorMsg(response.message);
         } else if (response.data && JSON.stringify(response.data) !== '{}') {
            if (response.data.failRecord && response.data.failRecord.length > 0) {
               this.$util.errorMsg(response.data.failRecord.join(';'));
            } else {
               this.$util.successMsg("导入成功");
               this.queryList();
            }
         } else {
            this.$util.successMsg("导入成功");
            this.queryList();
         }
      },
      //导入失败
      onError(response) {
         this.loading = false;
         if (response.status === 403) {
            this.SIGNOUT();
            location.href = "/#";
         }
         this.$util.errorMsg("导入失败");
      },
   }
}
</script>

<style scoped>
.action-wrapper {
   gap: 20px;
}
</style>


// WEBPACK FOOTER //
// BurnerAccount.vue?fdcaa5ca